import { generateDocSearchTerms, initDoc } from './../common/doc';
import { initLanscapeDesign } from './landscape-design';
export function initDesignConsultation(consultation) {
    const init = Object.assign(Object.assign({}, initDoc()), { collection: 'design-consultations', email: '', name: '', phone: '', acknowledged: false, closed: false, paused: false, design: initLanscapeDesign(), type: 'express', activityLog: [], searchTerms: [], slot: null });
    return Object.assign(Object.assign({}, init), consultation);
}
export function prepareDesignConsultation(consultation, isUpdate = false) {
    var _a, _b;
    consultation.id = consultation.id + ''; // ensure string
    if (isUpdate) {
        // ensure collection set.
        consultation.collection = 'design-consultations';
    }
    else {
        // if not an update, init full record
        consultation = initDesignConsultation(consultation);
    }
    consultation.searchTerms = generateDocSearchTerms(consultation.name, [
        consultation.id,
        consultation.phone,
        (_b = (_a = consultation.designerName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : 'no designer',
        consultation.email.toLowerCase()
    ]);
    return consultation;
}
export function initDesignConsultationDate(consultation) {
    const init = Object.assign(Object.assign({}, initDoc()), { collection: 'design-consultation-dates', date: undefined, designConsultationIds: [], slots: [] });
    return Object.assign(Object.assign({}, init), consultation);
}
export var DesignConsultationNoticeType;
(function (DesignConsultationNoticeType) {
    DesignConsultationNoticeType["CONFIRMATION"] = "CONFIRMATION";
    DesignConsultationNoticeType["REQUEST_INFORMATION"] = "REQUEST_INFORMATION";
})(DesignConsultationNoticeType || (DesignConsultationNoticeType = {}));
